import { useContext } from "react";
import { GlobalModalContext } from "state/GlobalModalProvider";

export function useOpenHelpCenter(): () => void {
    const { openHelpCenter } = useContext(GlobalModalContext);
    return openHelpCenter;
}
